import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'

export default function Material() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    // const [name, setName] = useState('')
    const [searchParams, setSearchParams] = useSearchParams()
    let name = searchParams.get('name') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || '1'
    // const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`dbms/materials?limit=0&name=${name}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [name])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายละเอียดวัสดุ
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">
                        <Link to='/setting/materials/add'>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>

                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={name} onChange={e => setSearchParams({ name: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา รหัส / ชื่อ"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>

                                        <th class="text-center">ชื่อวัสดุ</th>
                                        <th class="text-center">ระบุขนาด</th>
                                        <th class="text-center">หน่วย</th>
                                        <th class="text-center">สถานะ</th>
                                        <th></th>

                                    </tr>
                                </thead>
                                <tbody class="cp">
                                    {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                        <tr className={id === x?.ItemNo ? 'active' : ''}>
                                            <td class="text-center">{x?.ItemName}</td>
                                            <td class="text-center">{x?.CatalogNo?.RequireSize ?
                                                <span class="status-active">
                                                    ใช่
                                                </span> :
                                                <span class="status-inactive">
                                                    ไม่ใช่
                                                </span>
                                            }</td>
                                            <td class="text-center">{x?.UnitNo?.UnitName}</td>
                                            <td class="text-center">
                                                {x?.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span> :
                                                    <span class="status-inactive">
                                                        ไม่ใช้งาน
                                                    </span>}
                                            </td>
                                            <td class="text-center">
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}
                                                    onClick={e => {
                                                        setSearchParams({ id: x?.ItemNo, page: page, name: name, })
                                                        navigate(`/setting/materials/${x.ItemNo}`)
                                                    }}>เรียกดู</Button>
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, name: name, id: id })} shape="rounded" />

                    </div >
                </div >
            </div >
        </Page >
    )
}
